import React from "react";
import howLongAgo from "../../../util/timeDescription";
import {
    earningsWidth, latestActivityWidth, openIdeasWidth, orgNameWidth, priceChangeTodayChangeWidth,
    sentimentOneDayChangeWidth, sentimentTodayValueWidth, tickerWidth
} from "./stockStyles";
import {Link} from "react-router-dom";
import ActivityRow from "../../idea/ActivityRow";
import PercentageChange from "../../performance/PercentageChange";
import {SentimentChange, SentimentValue} from "../sentiment/Sentiment";
import {
    almostInvisibleShadedBackgroundColour, subduedTextColour, tableBorderColour, triggerColour
} from "../../../style/styleConsts";
import IdeaCounts from "../../idea/IdeaCounts";
import {EarningsProximity} from "../earnings/StockEarnings";
import StockAction from "../activity/StockAction";
import {logAction} from "../../../logging/logEvent";

const bold = { fontWeight: 'bold' };

const stockCellStyle = {
    padding: '7px 5px',
    flex: "0 1",
    overflow: "hidden"
};

const Cell = ({style = {}, className, onClick, children}) => (
    <div role="gridcell" className={`ReactVirtualized__Table__rowColumn ${className}`} style={{...stockCellStyle, ...style}} onClick={onClick}>
        {children}
    </div>
);

function produceActRows(activity, showIdeaDetail) {
    return activity.map((action, index) =>
        <ActivityRow dateTime={action.dateTime} action={action.action} key={index} onClick={() => showIdeaDetail(action.ideaId)}>
            <StockAction {...action} />
        </ActivityRow>);
}

function StockRow({stock, style, rowSelectFunction, renderExpanded, showIdeaDetail}) {
    const contents = [];
    const navigateToStockPage = () => {
        logAction({type: `STOCK_ROW_CLICKED`, orgId: stock.orgId, name: stock.name});
    };
    const onActivityClick = (e) => {
        // block the click event from bubbling up and triggering navigateToStockPage
        e.stopPropagation();
        e.preventDefault();
        rowSelectFunction();
    };
    contents.push(
        <Link onClick={navigateToStockPage}
              className="t-stock-link"
              key="main"
              to={`/stock/${stock.orgId}`}
              style={{color: "inherit", textDecoration: "none"}}>
            <div role="row" className="ReactVirtualized__Table__row t-stock-row" style={{borderTop: `1px solid ${tableBorderColour}`, cursor: "pointer"}}>
                <Cell className="t-ticker" style={{...bold, ...tickerWidth}}>{stock.bloomberg}</Cell>
                <Cell className="t-name" style={orgNameWidth}>{stock.name}</Cell>
                <Cell className="t-open-ideas" style={openIdeasWidth}>
                    <IdeaCounts openIdeas={stock.openIdeas}/>
                </Cell>
                <Cell className="t-latest-activity"
                      style={{color: subduedTextColour, ...latestActivityWidth, ...(renderExpanded ? {color: triggerColour} : {})}}
                      onClick={onActivityClick}>
                    {stock.latestActivity ? <div style={{ marginRight: 5, display: "inline-block", fontSize: 14, transform: renderExpanded ? "rotate(90deg)" : ""}}>›</div> : null}
                    {howLongAgo(stock.latestActivity)}
                </Cell>
                <Cell className="t-sentiment-today-value" style={sentimentTodayValueWidth}><SentimentValue sentiment={stock.sentiment}/></Cell>
                <Cell className="t-sentiment-one-day-change" style={sentimentOneDayChangeWidth}><SentimentChange sentiment={stock.sentiment}/></Cell>
                <Cell className="t-price-change-today" style={{...priceChangeTodayChangeWidth}}><PercentageChange change={stock.priceChangeToday}/></Cell>
                <Cell className="t-earnings" style={{...earningsWidth}}><EarningsProximity earnings={stock.earnings}/></Cell>
            </div>
        </Link>
    );
    if (renderExpanded) {
        contents.push(
            <div key="activity" style={{padding: "2px 0 2px 30px"}}>
                {produceActRows(stock.activity, showIdeaDetail)}
            </div>
        );
    }
    return <div style={{
                    ...style,
                    backgroundColor: renderExpanded ? almostInvisibleShadedBackgroundColour : "transparent"
                }}>
        {contents}
    </div>;
}

export default StockRow;
